<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <CallTimeGroupList></CallTimeGroupList>
    </template>
  </BasicLayout>
</template>

<script>
  import BasicLayout from '../../../../layouts/BasicLayout';
  import CallTimeGroupList from '../../../../components/tsConfig/hytalkPro/system/CallTimeGroupList';

  export default {
    name: 'SystemCallTimeGroup',
    components: {
      BasicLayout,
      CallTimeGroupList
    },
    data() {
      return {
        left: {
          show: false,
          name: ''
        },
        middle: {
          show: false,
          name: ''
        },
        right: {
          show: true,
          crumb: '111/22222/33333'
        }
      };
    }
  };
</script>

<style scoped>

</style>
